var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SwitchFlag',_vm._g({attrs:{"value":_vm.value,"label-mapping":_vm.labelMapping}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }